export class ResetPasswordRequestModel {
    public key: string;
    public secret: string;
    public newPassword: string;
    public confirmPassword: string;
}
